import { StateMachine } from "@/core/arch/state_machine";
import {
  fetchAuthSession,
  fetchUserAttributes,
  signOut,
} from "aws-amplify/auth";

interface AdminUserState {
  status: "loading" | "authenticated" | "unauthenticated" | "access_denied";
  email: string | null;
  groups: string[];
}

const initialState: AdminUserState = {
  status: "loading",
  email: null,
  groups: [],
};

export class AdminUserBloc extends StateMachine<AdminUserState> {
  constructor() {
    super(initialState);
  }

  async checkAuth(): Promise<void> {
    try {
      const session = await fetchAuthSession();
      const idToken = session.tokens?.idToken;

      if (!idToken) {
        this.setState({ ...initialState, status: "unauthenticated" });
        return;
      }

      const groups =
        (idToken.payload["cognito:groups"] as string[] | undefined) ?? [];

      if (!groups.includes("CPOS-Admin")) {
        await signOut();
        this.setState({
          status: "access_denied",
          email: null,
          groups: [],
        });
        return;
      }

      const attributes = await fetchUserAttributes();

      this.setState({
        status: "authenticated",
        email: attributes.email ?? null,
        groups,
      });
    } catch {
      this.setState({ ...initialState, status: "unauthenticated" });
    }
  }

  async logout(): Promise<void> {
    try {
      await signOut();
    } finally {
      this.setState({ ...initialState, status: "unauthenticated" });
    }
  }
}
